// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attachment-preview-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.preview-header {
  background: white;
  padding: 16px 24px;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  z-index: 10;
}

.preview-info h2 {
  margin: 0 0 4px 0;
  font-size: 18px;
  color: #2c3e50;
  word-break: break-word;
}

.preview-size {
  font-size: 12px;
  color: #6c757d;
  background: #e9ecef;
  padding: 2px 8px;
  border-radius: 3px;
  font-weight: 500;
}

.preview-actions {
  display: flex;
  gap: 12px;
}

.preview-actions button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.download-btn {
  background: #28a745;
  color: white;
}

.download-btn:hover {
  background: #218838;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.close-btn {
  background: #6c757d;
  color: white;
}

.close-btn:hover {
  background: #5a6268;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.preview-content {
  flex: 1 1;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.image-preview {
  max-width: 100%;
  max-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-preview img {
  max-width: 100%;
  max-height: calc(100vh - 120px);
  object-fit: contain;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  background: white;
  border-radius: 4px;
}

.pdf-preview {
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  overflow: hidden;
}

.pdf-preview iframe {
  border: none;
}

.preview-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 16px;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.preview-loading p {
  font-size: 16px;
  color: #6c757d;
}

.preview-error,
.unsupported-preview {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  max-width: 500px;
}

.error-icon,
.unsupported-icon {
  font-size: 64px;
  margin-bottom: 20px;
}

.preview-error h2,
.unsupported-preview h3 {
  margin: 0 0 12px 0;
  color: #2c3e50;
}

.preview-error p,
.unsupported-preview p {
  color: #6c757d;
  margin: 8px 0;
}

.preview-error .close-btn {
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/AttachmentPreview.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,uCAAuC;EACvC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".attachment-preview-page {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #f5f5f5;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.preview-header {\n  background: white;\n  padding: 16px 24px;\n  border-bottom: 1px solid #dee2e6;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  z-index: 10;\n}\n\n.preview-info h2 {\n  margin: 0 0 4px 0;\n  font-size: 18px;\n  color: #2c3e50;\n  word-break: break-word;\n}\n\n.preview-size {\n  font-size: 12px;\n  color: #6c757d;\n  background: #e9ecef;\n  padding: 2px 8px;\n  border-radius: 3px;\n  font-weight: 500;\n}\n\n.preview-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.preview-actions button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.download-btn {\n  background: #28a745;\n  color: white;\n}\n\n.download-btn:hover {\n  background: #218838;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.close-btn {\n  background: #6c757d;\n  color: white;\n}\n\n.close-btn:hover {\n  background: #5a6268;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.preview-content {\n  flex: 1;\n  overflow: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n}\n\n.image-preview {\n  max-width: 100%;\n  max-height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.image-preview img {\n  max-width: 100%;\n  max-height: calc(100vh - 120px);\n  object-fit: contain;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  background: white;\n  border-radius: 4px;\n}\n\n.pdf-preview {\n  width: 100%;\n  height: 100%;\n  background: white;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  overflow: hidden;\n}\n\n.pdf-preview iframe {\n  border: none;\n}\n\n.preview-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  gap: 16px;\n}\n\n.spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.preview-loading p {\n  font-size: 16px;\n  color: #6c757d;\n}\n\n.preview-error,\n.unsupported-preview {\n  text-align: center;\n  padding: 40px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n  max-width: 500px;\n}\n\n.error-icon,\n.unsupported-icon {\n  font-size: 64px;\n  margin-bottom: 20px;\n}\n\n.preview-error h2,\n.unsupported-preview h3 {\n  margin: 0 0 12px 0;\n  color: #2c3e50;\n}\n\n.preview-error p,\n.unsupported-preview p {\n  color: #6c757d;\n  margin: 8px 0;\n}\n\n.preview-error .close-btn {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
